import React from 'react';

const FinalCTASection = () => {
  return (
    <section className="py-32 px-6 bg-[#1B1B1B] text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[#0077C8]/5"></div>
      <div className="max-w-[800px] mx-auto text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-12 leading-tight">
          Stop hoping your controls will hold up. Know they will.
        </h2>
        <button 
          className="bg-[#0077C8] text-white px-12 py-6 rounded-lg text-xl font-bold hover:scale-[1.05] transition-transform shadow-2xl shadow-[#0077C8]/30 flex items-center gap-3 mx-auto"
          onClick={() => {
            window.location.href = "mailto:john@dagalagroup.com?subject=Provision 29 Readiness Call";
          }}
        >
          <span className="material-symbols-outlined text-2xl">calendar_today</span>
          <span>Book a Provision 29 Readiness Call</span>
        </button>
        <p className="mt-12 text-gray-500 text-xs font-bold tracking-[0.3em]">DEFENSIBLE ASSURANCE • PROFESSIONAL SERVICES • BOARD READY</p>
      </div>
    </section>
  );
};

export default FinalCTASection;
